import { useEffect, useMemo, useState } from 'react';

const SUPPORTED_LANGUAGES = ['RU', 'KY', 'EN'];

// Shared across every page: language comes from ?lang= in the URL, falling back
// to the browser's language, and stays switchable via the header's language pill.
export default function useLanguage(location, apiSender) {
  const [language, setLanguage] = useState('RU');

  const paramsObject = useMemo(
    () => Object.fromEntries(new URLSearchParams(location.search).entries()),
    [location.search]
  );

  useEffect(() => {
    const urlLang = paramsObject.lang?.toUpperCase();
    const browserLang = apiSender.getBrowserLang('RU');
    setLanguage(SUPPORTED_LANGUAGES.includes(urlLang) ? urlLang : browserLang);
  }, [paramsObject.lang, apiSender]);

  const selectLanguage = (lang) => {
    if (SUPPORTED_LANGUAGES.includes(lang)) setLanguage(lang);
  };

  // Picks the right string for the current language: t(russian, kyrgyz, english)
  const t = (ru, ky, en) => (language === 'RU' ? ru : language === 'KY' ? ky : en);

  return { language, selectLanguage, t, paramsObject };
}
